
var sprite = require("/Users/fizz/side/antd-mobile/node_modules/svg-sprite-loader/lib/web/global-sprite");
var image = "<symbol viewBox=\"0 0 44 44\" id=\"check\" ><title>Operation Icons Copy 6</title><path d=\"M34.538 8L38 11.518 17.808 32 8 22.033l3.462-3.518 6.346 6.45z\" fill-rule=\"evenodd\"/></symbol>";
module.exports = sprite.add(image, "check");


/*****************
 ** WEBPACK FOOTER
 ** ./components/icon/style/assets/check.svg
 ** module id = 464
 ** module chunks = 0
 **/